import { Component, Input, OnDestroy } from "@angular/core";
import {  Subject,  } from "rxjs";
import { filter, takeUntil } from "rxjs/operators";
import { TooltipReaderService } from "src/app/services/tooltip-reader.service";

@Component({
  selector: "tooltip-reader",
  templateUrl: "./tooltip-reader.component.html",
  styleUrls: ["./tooltip-reader.component.css"],
})
export class TooltipReaderComponent implements OnDestroy {
  constructor(readonly tooltipReaderService: TooltipReaderService) {}
  
  tooltipText: string;
  private __fieldName;
  private __registerName;
  private __destroy$ = new Subject();

  ngOnDestroy(): void {
    this.__destroy$.complete();
  }

  @Input()
  set register(value: string) {
    if (!value){
      return;
    }

    this.__registerName = value;
    this.tooltipReaderService
      .loadTooltip(value)
      .pipe(filter((f) => !!f))
      .pipe(takeUntil(this.__destroy$))
      .subscribe(() => {
        this.setToolTip()
      });
  }

  @Input()
  set field(value: string) {
    this.__fieldName = value;
    this.setToolTip();
  }

  setToolTip() {
    if (this.tooltipText || !this.__registerName || !this.__fieldName) {
      return;
    }
    this.tooltipText = this.tooltipReaderService.getTooltipForRegisiter({
      registerName: this.__registerName,
      fieldName: this.__fieldName,
    });
  }
}
